import AboutComp from "../components/about_component/About";

const AboutP = () => {
    return ( 
        <>
        <AboutComp/>
        </>
     );
}
 
export default AboutP;